// extracted by mini-css-extract-plugin
module.exports = {"root":"_b9c044","card":"_c1edee","content":"_2eb85c","imageDiv":"_362ef8","title":"_cb5faf","info":"_f8ac9c"};